import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Backdrop, Box, Fade, Modal} from "@mui/material";

import styles from './SearchBar.module.scss';
import searchIcon from "../../constants/images/search.svg";
import filterIcon from "../../constants/images/filter.svg";
import FiltersModalForCleaners from "../FiltersModalForCleaners/FiltersModalForCleaners";
import FiltersModalForCustomers from "../FiltersModalForCustomers/FiltersModalForCustomers";
import OrderingBy from "../OrderingBy/OrderingBy";
import BadgeFilter from "../BadgeFilter/BadgeFilter";
import {filtersForCustomerActions} from "../../store/slices/filtersForCustomerSlice";
import {filtersForCleanerActions} from "../../store/slices/filtersForCleanerSlice";

const SearchBar = ({type, page, setPage}) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const dispatch = useDispatch();
    const {
        min_price: minPriceCustomer,
        max_price: maxPriceCustomer,
        searchValue: searchValueCustomer
    } = useSelector(state => state.filtersForCustomer);
    const {
        min_price: minPriceCleaner,
        max_price: maxPriceCleaner,
        searchValue: searchValueCleaner,
        package_names
    } = useSelector(state => state.filtersForCleaner);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 4
    };

    const handleClearPrice = (type) => {
        if (type === 'min') {
            if (minPriceCustomer) {
                dispatch(filtersForCustomerActions.setMinPrice(null));
            } else {
                dispatch(filtersForCleanerActions.setMinPrice(null));
            }
        } else {
            if (maxPriceCustomer) {
                dispatch(filtersForCustomerActions.setMaxPrice(null));
            } else {
                dispatch(filtersForCleanerActions.setMaxPrice(null));
            }
        }

        dispatch(filtersForCustomerActions.setTrigger());
        dispatch(filtersForCleanerActions.setTrigger());
    }

    const handleFilterByName = () => {
        if (type === 'customer') {
            dispatch(filtersForCustomerActions.setSearchValue(searchValue));
            dispatch(filtersForCustomerActions.setTrigger());
        } else {
            dispatch(filtersForCleanerActions.setSearchValue(searchValue));
            dispatch(filtersForCleanerActions.setTrigger());
        }
    }


    const handleClearSearchValue = () => {
        setSearchValue('');
        dispatch(filtersForCustomerActions.setSearchValue(''));
        dispatch(filtersForCleanerActions.setSearchValue(''));

        dispatch(filtersForCustomerActions.setTrigger());
        dispatch(filtersForCleanerActions.setTrigger());
    }

    const handleClearPackageName = () => {
        dispatch(filtersForCleanerActions.setPackageNames(''));
        dispatch(filtersForCleanerActions.setTrigger());
    }

    const handleEnterPress = (event) => {
        if (event.key === 'Enter') {
            handleFilterByName();
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.searchBar}>
                <div className={styles.searchBar_search}>
                    <input
                        type="text"
                        placeholder={'Пошук'}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={handleEnterPress}
                    />
                    <div onClick={handleFilterByName}>
                        <img src={searchIcon} alt="search icon"/>
                    </div>
                </div>

                <div className={styles.searchBar_sorting}>
                    <p>Сортувати:</p>
                    <OrderingBy type={type}/>
                </div>

                <div className={styles.searchBar_filter}>
                    <button
                        onClick={() => setIsFilterOpen(true)}
                        className={styles.searchBar_filter_button}
                    >
                        <img src={filterIcon} alt="filter icon"/>
                        <p>Фільтр</p>
                    </button>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={isFilterOpen}
                        onClose={setIsFilterOpen}
                        closeAfterTransition
                        slots={{backdrop: Backdrop}}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                    >
                        <Fade in={isFilterOpen}>
                            <Box sx={style}>
                                {type === 'cleaner' &&
                                    <FiltersModalForCleaners
                                        page={page}
                                        setPage={setPage}
                                        handleClose={() => setIsFilterOpen(false)}
                                    />}
                                {type === 'customer' &&
                                    <FiltersModalForCustomers
                                        handleClose={() => setIsFilterOpen(false)}
                                        page={page}
                                        setPage={setPage}
                                    />}
                            </Box>
                        </Fade>
                    </Modal>
                </div>
            </div>

            {(minPriceCleaner || maxPriceCleaner || maxPriceCustomer || minPriceCustomer || searchValueCustomer || searchValueCleaner || package_names) &&
                <div className={styles.badges}>
                    {(minPriceCustomer || minPriceCleaner) &&
                        <BadgeFilter
                            title={`Від ₴${minPriceCustomer || minPriceCleaner}`}
                            onClick={() => handleClearPrice('min')}
                        />}
                    {(maxPriceCustomer || maxPriceCleaner) &&
                        <BadgeFilter
                            title={`До ₴${maxPriceCustomer || maxPriceCleaner}`}
                            onClick={() => handleClearPrice('max')}
                        />}
                    {(searchValueCleaner || searchValueCustomer) &&
                        <BadgeFilter
                            title={`Пошук по імені: ${searchValueCleaner || searchValueCustomer}`}
                            onClick={handleClearSearchValue}
                        />}
                    {package_names &&
                        <BadgeFilter
                            title={`Тип прибирання: ${package_names}`}
                            onClick={handleClearPackageName}
                        />}
                </div>
            }
        </div>
    );
};

export default SearchBar;
